module.exports = __webpack_public_path__ + "img/icon (11).61e60ba1.png";